import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "../assets/scss/Views/player.scss";
import VideoPlayer from "../Components/VideoPlayer/VideoPlayer";
import { pathData } from "../data/pathsData";
function Player({
  setPageTitle,
  setShowMenuToggler,
  setReturnLink,
  setIsBackgroundMusic,
}) {
  const { t } = useTranslation();
  const [videoData, setVideoData] = useState();
  const [resumeAt, setResumeAt] = useState();
  const [pathName, setPathName] = useState();
  let { id } = useParams();

  useEffect(() => {
    setPageTitle(t(pathName));
    setShowMenuToggler(true);
    setIsBackgroundMusic(false);
    setReturnLink({ link: "/scene" });
  }, [
    setPageTitle,
    pathName,
    setShowMenuToggler,
    setReturnLink,
    setIsBackgroundMusic,
    t,
  ]);

  useMemo(() => {
    const pathId = parseInt(id);
    const { videos, name } = pathData[pathId];
    setPathName(name);
    setVideoData(videos);
  }, [id]);

  useMemo(() => {
    setTimeout(() => {
      try {
        let data = JSON.parse(
          localStorage.getItem("zarastanie_video_progress")
        );
        if (data) {
          setResumeAt(data[id]);
        }
      } catch (error) {}
    }, 400);
  }, [id]);

  return (
    <div>
      {videoData && (
        <VideoPlayer
          initialVideosData={videoData}
          resumeAt={resumeAt}
          pathName={pathName}
        />
      )}
    </div>
  );
}

export default Player;
